import * as React from 'react'
import cx from 'classnames'
import styles from './last.update.styl'
import { formatDateTime } from '@src/utils/date.helpers'
import type { DateInput } from '@src/utils/date.helpers'

interface Props {
  lastUpdate?: DateInput
  className?: string
}

const LastUpdate: React.FC<Props> = (props: Props) => {
  const { lastUpdate, className } = props

  return (
    <span
      role={`header_last_update`}
      className={cx(styles.lastUpdate, 'lastUpdate', className)}
    >
      Last update: {formatDateTime(lastUpdate)}
    </span>
  )
}

export default LastUpdate
